/**
 * @file オプション設定
 */
'use strict';
// utility class
import ApplyClass from '../util/_apply-class';
import CartProductTemplate from '../template/_cart-product';
import RemoveCartOptionView from './_remove-cart-option-view';


/**
 * @classname FeeProductInitializeView
 * @classdesc オプションモーダル
 */
export default class FeeProductInitializeView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - コントローラー
	 */
	constructor($e, controller) {
		console.log('FeeProductInitializeView.constructor');
		this._$e = $e;
		this._controller = controller;
		this.init();
	};


	/**
	 * 初期化
	 *
	 * @memberof FeeProductInitializeView
	 * @return {undefined}
	 */
	init() {
		console.log('FeeProductInitializeView.init');
		const productId = this._$e.attr('data-product-id');
		const skuId = this._$e.attr('data-sku-id');
		const skuName = this._$e.attr('data-sku-name');
		const image = this._$e.attr('data-image');
		const productName = this._$e.attr('data-product-name');
		const price = this._$e.attr('data-price');
		const quantity = this._$e.attr('data-quantity');
		const cartProduct = CartProductTemplate.cartProduct(productId, skuId, skuName, image, productName, price, quantity);
		//console.log(cartProduct);
		$('.list-cart-product').append(cartProduct);
		const controller = this._controller;
		$('.remove-option').each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(RemoveCartOptionView, $e, [$e, controller]);
		});
		this._controller.calculate();
	};
}
